// extracted by mini-css-extract-plugin
module.exports = {"container":"RuleModal_container__3PyLw","flexCurt":"RuleModal_flexCurt__3T6Tv","curt":"RuleModal_curt__2QgQJ"};